document.addEventListener('DOMContentLoaded', function() {
  const tabList = document.querySelector('.benefits-toggle-tab-audience-view__tab-list');
  const tabItems = document.querySelectorAll('.benefits-toggle-tab-audience-view__tab-list-item');
  const tabContent = document.querySelectorAll('.benefits-toggle-tab-audience-view__tab-content');

  if (tabList && tabItems && tabContent) {
    tabList.addEventListener('click', function(event) {
      const clickedTab = event.target.closest('.benefits-toggle-tab-audience-view__tab-list-item');
      const anchor = event.target.closest('a');

      if (clickedTab && anchor) {
        event.preventDefault();

        // Custom horizontal scrolling that doesn't affect vertical position
        const tabListRect = tabList.getBoundingClientRect();
        const clickedTabRect = clickedTab.getBoundingClientRect();

        // Calculate the scroll position to center the tab
        const scrollLeft = clickedTab.offsetLeft - tabListRect.width / 2 + clickedTabRect.width / 2;

        // Smooth scroll horizontally only
        tabList.scrollTo({
          left: scrollLeft,
          behavior: "smooth",
        });

        // Remove active class from all tabs
        tabItems.forEach(item => {
          item.classList.remove('active');
        });

        // Add active class to the clicked tab
        clickedTab.classList.add('active');

        const targetId = anchor.getAttribute('href');

        // Hide all table content and show the target content
        tabContent.forEach(content => {
          content.classList.remove('active');
          if (content.id === targetId) {
            content.classList.add('active');
          }
        });
      }
    });
  }
});